/**
 * Legacy Firma-linked signing templates.
 *
 * Before the native e-signature system, a saved signing template could be
 * linked to a Firma document template (firmaTemplateId): the document and
 * its fields lived in Firma, so the template record carries neither a
 * native document (pdfStoragePath / pdfDataUrl) nor native field
 * definitions. Such a template cannot be sent with the native system —
 * request creation refuses it with NO_DOCUMENT — so the admin surfaces
 * flag it instead of letting it dead-end at send time.
 *
 * The stored record itself is never migrated or deleted; this predicate
 * only drives presentation (badge in the template manager, exclusion
 * from send pickers).
 */
export interface LegacySigningTemplateShape {
  firmaTemplateId?: string | null;
  pdfStoragePath?: string | null;
  pdfDataUrl?: string | null;
  fields?: unknown[] | null;
}

export function isLegacyFirmaTemplate(
  tpl: LegacySigningTemplateShape | null | undefined,
): boolean {
  if (!tpl) return false;
  if (!tpl.firmaTemplateId || !String(tpl.firmaTemplateId).trim()) return false;
  if (tpl.pdfStoragePath || tpl.pdfDataUrl) return false;
  if (Array.isArray(tpl.fields) && tpl.fields.length > 0) return false;
  return true;
}
